import { LOCALES } from "../locales";

export default {
  [LOCALES.PORTUGESE]: {
    // general product translation
    January: "Janeiro",
    February: "Fevereiro",
    March: "Março",
    April: "Abril",
    May: "Maio",
    June: "Junho",
    July: "Julho",
    August: "Agosto",
    September: "Setembro",
    October: "Outubro",
    November: "Novembro",
    December: "Dezembro",
    class_policy: "Política da aula",
    Faq: "FAQs",
    help: "Ajuda",
    category: "categoría",
    frequently_asked_ques: "Perguntas frequentes",
    customer_support: "Suporte ao cliente",
    user_name: "Nome de usuário",
    password: "Senha",
    email_address: "Endereço de e-mail",
    // Header Translations
    notification: "Notificação",
    page_loading_aria: "Carregando a página",
    state_loading_aria: "O etado está sendo carregado",
    city_loading_aria: "A cidade está sendo carregada",
    badge_placeholder: "Badge placeholder",
    badge_overall: "Emblema geral",
    badge_demo_skills: "Badge placeholder for demo user, skills",
    badge_demo_be: "Badge placeholder for demo user, Business English",
    certificate_placeholder: "Imagem do certificado",
    certificate_download: "Botão de download do certificado",
    prev: "Anterior",
    log_out: "Sair",
    //navbar
    navbar_course: "Curso",
    navbar_tools: "Ferramentas",
    navbar_skill_index: "Habilidades",
    navbar_level_index: "Níveis",
    navbar_schedule: "Horários",
    // feature names
    feature_progress: "Progresso",
    feature_stressAndIntonation_title: "Ênfase e entonação",
    feature_soundOfEnglish_title: "Sons do inglês",
    feature_vocabularyCenter_title: "Centro de Vocabulário",
    feature_grammarCenter_title: "Centro de Gramática",
    feature_culture_centre_title: "Centro de Cultura",
    feature_globalCommunityTutorials_title: "Global community tutorials",
    feature_industryfeed_title: "Feed por indústria",
    feature_newsfeed_title: "News feed",
    feature_emailTemplates_title: "Modelos de e-mail",
    feature_talkWithTeacher_title: "Talk with the Teacher",
    feature_accentsAndDialects_title: "Sotaques e dialetos",
    feature_writingCenter_title: "Centro de Redação",
    feature_toeic_title: "TOEIC®",
    feature_toefl_title: "TOEFL®",
    // Footer translations
    about: "Sobre",
    legal: "Jurídico",
    privacy_policy: "Política de privacidade",
    Terms_conditions: "Termos De Uso",
    //button translations
    button_continue: "Continuar",
    button_KnowMore: "Saiba mais",
    button_BuyNow: "Compre agora",
    button_Subscribe: "Inscreva-se",
    button_GetStarted: "Iniciar",
    button_GetResult: "Obter resultados",
    button_GetLoading: "Loading...",
    button_view: "Visualizar",
    button_GoText: "Ir",
    button_Resume: "Continuar aprendendo",
    button_ViewDetails: "Ver detalhes",
    button_ContinueStudying: "Continuar",
    button_next: "Avançar",
    button_confirm: "Confirmar",
    // cookie policy
    common_cookiesPolicyText1:
      "Ao continuar usando este site, você concorda com o uso de cookies para lhe fornecer melhores serviços. Leia nossa",
    common_cookiesPolicyText2: "Política de cookies",
    // EO cookie policy
    //login-page-translations//
    login_welcome: "Bem-vindo(a)",
    login_heloo: "Olá novamente",
    login_welcome_text: "Vamos começar",
    login_log_in: "Entrar",
    login_errorIncorrectCreds: "Nome de usuário ou senha incorretos",
    login_errorContactAmin: "A sua conta não está ativa. Entre em contato com seu administrador.",
    login_errorSSOuser: "Entre na sua conta através do portal de aprendizagem da sua empresa.",
    login_forgotPassword: "Esqueceu a senha?",
    login_resetPasswordTitle: "Redefinir senha",
    login_resetSuccess: "Enviamos um e-mail contendo um link que permitirá que você redefina sua senha.",
    login_resetFailure: "O endereço de e-mail está incorreto",
    // common translations
    message_errorDefault: "Algo deu errado",
    message_successUpdated: "Atualizado com sucesso",
    message_unknownError: "Erro desconhecido",
    message_unAuthorized: "Você não está autorizado a acessar esta página",
    message_passwordUpdated: "Senha atualizada com sucesso",
    message_profileUpdated: "Perfil atualizado com sucesso",
    message_welcomeSubmitted: "Enviado com sucesso",
    message_samepasswordError:
      "Por favor, insira uma nova senha. Certifique-se que não seja uma senha usada anteriormente.",
    SAR: "Selecione uma região",
    SAL: "Selecione uma localização",
    SAT: "Selecione um tema",
    SAA: "Selecione o idioma",
    link_readmore: "Leia mais",
    //--//
    profile_title: "Perfil",
    profile_nameLabel: "Meu nome é:",
    profile_countryLabel: "País",
    profile_stateLabel: "Estado / província / região",
    profile_cityLabel: "Cidade",
    profile_emailLabel: "E-mail",
    profile_prefContactLabel: "Contato preferencial",
    profile_prefSkypeLabel: "Skype (pessoal) ID",
    profile_prefMobileLabel: "Número de celular",
    profile_prefLandlineLabel: "Número de telefone fixo",
    profile_agreeTerms1: " ",
    profile_agreeTerms2: "Eu aceito e concordo com o termos e condições",
    profile_continueAria: "Botão continuar",
    profile_TermsAria: "Aceitar termos e condições",
    profile_stateTooltip: "Seu fuso horário nos ajudará a agendar suas sessões online",
    profile_cityTooltip: "Se você não mora em uma das cidades mostradas aqui, escolha a mais próxima a você.",
    profile_emailTooltip: "Verifique seu e-mail",
    profile_prefTooltip:
      "Todas as suas sessões ocorrerão na sala de aula virtual, mesmo que você tenha especificado um método de contato diferente no processo de embarque. Nós lhe perguntamos sobre seu método de contato preferencial apenas para uso interno para que possamos melhorar continuamente sua experiência de aprendizagem.",
    profile_fnamePlaceholder: "Nome",
    profile_lnamePlaceholder: "Sobrenome",
    profile_countryPlaceholder: "Selecione um país",
    profile_prefContactSelect: "Selecione sua preferência",
    profile_statePlaceholder: "Selecione um estado",
    profile_cityPlaceholder: "Selecione uma cidade",
    profile_emailInvalidMessage: "O endereço de e-mail está inválido",
    profile_prefContactPlaceholder: "Escolha sua preferência",
    profile_prefSkypePlaceholder: "Skype (pessoal)",
    profile_emailVerifiedChip: "Verificado",
    profile_emailVerifyChip: "Verificar",
    profile_emailpopup_head: "Digite o código de verificação",
    profile_emailpopup_codePlaceholder: "Code",
    profile_emailpopup_resendText: "Reenviar código",
    profile_emailpopup_resendMessage: "Não recebeu o código?",
    profile_invalidNumber: "Número inválido",
    profile_prefSkypeAria: "ID do Skype (pessoal) como contato principal",
    profile_prefMobileAria: "Celular como contato principal",
    profile_prefLandlineAria: "Telefone fixo como contato principal",
    profile_emailpopup_incorrectCode: "Código inválido",
    profile_editLabel: "Editar perfil",
    profile_editAria: "Botão de edição",
    profile_mainPasswordPlaceholder: "Digite a senha aqui",
    profile_updateLabel: "Atualizar",
    profile_welcomeJumbotron: "Fale sobre você",
    profile_cancelLabel: "Cancelar",
    noAccessl1: "Ops! Você não tem permissão para visualizar esta página!",
    noAccessl2: "Aqui está um link de volta para",
    noAccessl2_1: "Pagina inicial",
    noAccessl3: "Por favor, entre em contato com seu administrador da Learnship para obter ajuda.",
    license_information: "Minha licença",
    profile_license_information: "Informações sobre licença",
    profile_license_message: "Sua licença expira em",
    profile_changepass_changepassHead: "Mude sua senha",
    profile_changepass_currentpassword: "Senha atual",
    profile_changepass_currentpasswordPlaceholder: "Digite a senha atual",
    profile_changepass_newpassword: "Nova senha",
    profile_changepass_newpasswordPlaceholder: "Digite a nova senha",
    profile_changepass_confirmnewpassword: "Confirmar nova senha",
    profile_passMustInclude: "Sua senha deve atender aos seguintes requisitos:",
    profile_passdontmatch: "Senhas não coincidem",
    profile_incorrectPassword: "Senha incorreta",
    profile_passwordSubmit_title: "Digite a senha",
    profile_changepass_conditionLength: "Entre 8 e 32 caracteres",
    profile_changepass_conditionUppercase: "Pelo menos uma letra maiúscula",
    profile_changepass_conditionLowercase: "Pelo menos uma letra minúscula",
    profile_changepass_conditionSpecialCharacters: "Pelo menos um dígito numérico e um destes símbolos $!#&@?%*_",
    profile_translationLanguage: "Idioma de tradução",
    profile_translationLanguagePlaceholder: "Escolha um idioma",
    profile_managerEmailPlaceholder: "E-mail do gerente",
    profile_managerEmailpopupPlaceholder: "Endereço de e-mail do gerente",
    // Learner Home Page translations
    learnerhome_survey_header: "Precisamos do seu feedback!",
    learnerhome_survey_line1: "Sua empresa deseja saber sobre sua experiência utilizando nosso serviço.",
    learnerhome_survey_line2: "Por favor, complete a nossa pesquisa até",
    learnerhome_survey_line3: "Seu feedback é muito importante para nós.",
    learnerhome_survey_button1: "Responder pesquisa",
    learnerhome_survey_button2: "Pular pesquisa",
    active_course: "Curso ativo",
    admin_header: "Administração",
    admin_dashboard_header: "Dashboard",
    get_startedText: "Clique no curso abaixo para começar.",
    product_solo_desc:
      "Learnship solo, nosso produto de e-learning, fornece tudo o que os alunos precisam para praticar e melhorar suas habilidades linguísticas de negócios em seu próprio ritmo.",
    product_conversationPractice_desc:
      "Os alunos podem reservar sessões individuais com instrutores para fazer perguntas, discutir uma questão específica ou cenários de dramatização. Util para alunos mais experientes que procuram refinar suas habilidades.",
    product_sprint_businessSkills_desc:
      "Este programa de aprendizagem combinada de última geração ajuda os alunos a desenvolver habilidades de negócios específicas, como apresentação de negócios, negociações, redação comercial e participação em reuniões - em tempo recorde.",
    product_sprint_levelsProgress_desc:
      "Nosso programa de aprendizagem combinada de última geração ajuda os alunos a melhorar de maneira mais rápida suas habilidades no idioma inglês quando comparado a uma estrutura padronizada.",
    product_sprint_business_german_desc:
      "Nosso programa combinado de última geração ajuda seu pessoal a melhorar rapidamente suas habilidades em alemão em comparação a uma estrutura padronizada de ensino de idiomas.",
    product_sprint_business_french_desc:
      "Nosso programa combinado de última geração ajuda seu pessoal a melhorar rapidamente suas habilidades em francês em comparação a uma estrutura padronizada de ensino de idiomas.",
    product_sprint_business_spanish_desc:
      "Nosso programa combinado de última geração ajuda seu pessoal a melhorar rapidamente suas habilidades em espanhol em comparação a uma estrutura padronizada de ensino de idiomas.",
    product_sprint_business_skills_groups_desc:
      "This next-generation blended learning program helps learners develop specific business skills— in groups—in record time.",
    product_evolve_relocationLanguage_desc:
      "Nosso programa de realocação de funcionários ajuda os alunos a desenvolver uma compreensão mais profunda do idioma e das nuances sociais de seu novo país de residência.",
    product_evolve_culturePowerSkills_desc:
      "Dê aos seus funcionários as habilidades interculturais de que precisam para prosperar em ambientes de trabalho internacionais e equipes virtuais globais.",
    product_evolve_cultureFocus_desc:
      "Treinamento específico para cada país e inteligência cultural para alunos que precisam obter uma melhor compreensão de uma região específica e sua cultura de trabalho.",
    product_evolve_cultureChange_desc:
      "Este é o nosso programa intercultural de primeira linha de treinamento de negócios para expatriados. Ele oferece aos alunos uma compreensão profunda do que é necessário para viver e trabalhar em uma nova cultura.",
    product_elevate_businessSkills_desc:
      "Módulos de treinamento curtos e padronizados para alunos de línguas que desejam aprimorar habilidades específicas de negócios, como apresentação, negociação ou liderança de equipe. Também oferecemos cursos especializados focados em dialetos específicos da indústria.",
    product_elevate_levelsProgress_desc:
      "Este curso de linguagem empresarial ministrado por instrutores ajuda os alunos a melhorar suas habilidades escritas e orais quando comparado a uma estrutura padronizada.",
    product_coach_languageCoach_desc:
      "Comunique-se com confiança e clareza em salas de reuniões, e-mails, negociações e até mesmo durante a pausa do cafezinho. Nosso treinamento personalizado e hiper específico de linguagem executiva ajuda você a dominar os mais importantes cenários de negócios. Desenvolva suas habilidades de comunicação verbal, escrita, comercial e pessoal.",
    product_coach_cultureCoach_desc:
      "Um programa de coaching individual hiper focado para executivos que buscam solucionar problemas específicos de comunicação intercultural.",
    product_solo_business_english:
      "Um programa de aprendizagem multinível com exercícios online envolventes para desenvolver seu conhecimento e aplicação do inglês para negócios em seu próprio ritmo.",
    product_solo_business_german:
      "Um programa de aprendizagem multinível com exercícios online envolventes para desenvolver seu conhecimento e aplicação do alemão para negócios em seu próprio ritmo.",
    product_solo_business_french:
      "Um programa de aprendizagem multinível com exercícios online envolventes para desenvolver seu conhecimento e aplicação do francês para negócios em seu próprio ritmo.",
    product_solo_business_spanish:
      "Um programa de aprendizagem multinível com exercícios online envolventes para desenvolver seu conhecimento e aplicação do espanhol para negócios em seu próprio ritmo.",
    product_lorem_desc: "Lorem ipsum lorstatment , consect eturadips cingelioremp.",
    product_dashboard_desc:
      "Esta é sua porta de acesso ao dashboard - uma interface intuitiva que permite aos administradores acompanhar seu uso, analisar o progresso do aluno, otimizar programas e avaliar o ROI.",
    product_elevate_desc:
      "O Elevate Business English é nosso treinamento de idiomas online, presencial para alunos que desejam melhorar sua proficiência linguística geral trabalhando com um instrutor particular.",
    product_reach_desc:
      "Enhance your learning journey with personalized micro-modules and side missions focusing on real-world business skills.",
    product_lorem_solo_desc:
      "Este rico programa de multimídia ajuda a sua equipe a melhorar rapidamente suas habilidades no idioma inglês quando comparado a uma estrutura padronizada.",
    //feature translations
    feature_cultureCentre_desc:
      "Familiarize-se com as culturas das regiões que são importantes para seus negócios e vida profissional.",
    feature_emailTemplates_desc:
      "Os modelos de e-mail abrangem uma ampla variedade de assuntos sobre o mundo dos negócios. Selecione o modelo desejado e exporte-o diretamente para o seu e-mail de trabalho, onde poderá editá-lo.",
    feature_newsFeed_desc:
      "Bem-vindo(a) a uma experiência de leitura de notícias e aprendizado de inglês onde conteúdo e perguntas são gerados ao vivo, o que lhe dá acesso às notícias mundiais e ajuda a melhorar seu inglês.",
    feature_talkWithTeacher_desc:
      "Isto é para os alunos que desejam aplicar suas novas habilidades na conversação. Os usuários podem se juntar a um grupo em uma sala de aula virtual para praticar o idioma escolhido e de uma sessão de perguntas e respostas com especialistas em conversação.",
    feature_industryFeed_desc:
      "O feed por indústria combina uma biblioteca de artigos específicos da indústria com exercícios de linguagem baseados em IA. Escolha um artigo junto com um ponto de gramática que você deseja praticar…",
    feature_accentsAndDialects_desc:
      "Explore a riqueza do uso global do inglês através da nossa biblioteca de amostras de fala regionais.",
    feature_stressAndIntonation_desc:
      "Torne seu inglês mais natural e fácil de entender, aprendendo como usar a ênfase, o ritmo e a entonação corretos ao falar.",
    feature_soundOfEnglish_desc:
      "Melhore suas habilidades de comunicação aprendendo a pronunciar os sons do inglês corretamente.",
    feature_vocabularyCenter_desc:
      "Sem gramática, muito pouco pode ser transmitido. Sem vocabulário, nada pode ser transmitido. - David Wilkins",
    feature_grammarCenter_desc:
      "O Centro de Gramáticar irá contribuir para melhorar suas habilidades de fala e escrita. Uma variedade de tópicos gramaticais é coberta, tais como estrutura das frases, uso correto dos verbos e como escrever com palavras e frases de ligação.",
    feature_globalCommunityTutorials_desc:
      "Melhore suas habilidades no idioma inglês com esta coleção crescente de aulas desenvolvidas pela comunidade.",
    feature_toeic_desc:
      "O teste TOEIC® é o instrumento mais amplamente usado por empresas multinacionais para medir a proficiência em inglês dos funcionários. O TOEIC® usa materiais escritos e diálogos autênticos para avaliar suas habilidades de inglês para negócios.",
    feature_toefl_desc:
      "TOEFL®, o teste de inglês como língua estrangeira, é usado em todo o mundo por faculdades e universidades, agências governamentais e programas de bolsas de estudo para avaliar a proficiência em inglês.",
    feature_businessSituations_desc:
      "O índice de situações de negócios facilita a localização de atividades específicas para que você possa se concentrar no idioma de que precisa para se comunicar em uma variedade de situações de negócios.",
    //carousel block translations
    title_feature: "Recursos",
    we_recommend: "Nós também recomendamos",
    // session report translations
    SessionReport_sessionReport: "Relatório da sessão",
    SessionReport_sessionDetails: "Detalhes",
    SessionReport_teacherName: "Nome do professor",
    SessionReport_sessionReview: "Revisão da sessão",
    SessionReport_sessionFeedback: "Feedback da sessão",
    SessionReport_sessionMaterials_Assignments: "Materiais e tarefas da sessão",
    SessionReport_instructions: "Instruções",
    SessionReport_open: "Abrir",
    SessionReport_invalidSession_Message: "Desculpe, não há relatório para esta sessão.",
    SessionReport_rateSession: "Avalie sua sessão",
    SessionReport_handouts: "Apostilas",
    SessionReport_coachName: "Como foi sua sessão com",
    SessionRating_sessionDate: "Data da sessão",
    SessionRating_sessionTime: "Horário da sessão",
    SessionRating_sessionDuration: "Duração da sessão",
    SessionRating_status: "Status",
    SessionRating_rateYourExperience: "Avalie sua experiência",
    SessionRating_whatWentWrong: "O que deu errado?",
    SessionRating_content: "Conteúdo",
    SessionRating_technology: "Tecnologia",
    SessionRating_comment: "Deixe um comentário",
    SessionRating_submit: "Enviar",
    SessionRating_remindMeLater: "Lembre-me mais tarde",
    SessionRating_close: "Fechar",
    SessionRating_completed: "Concluído",
    sessionRating_sessionDetails_mins: "Minutos",
    // my schedule page translations
    myschedule_availability_abty_given: "Estamos trabalhando para encontrar um instrutor pra você.",
    myschedule_schedule: "Meu horário",
    myschedule_availability_needAvl: "Precisamos de sua disponibilidade para agendar a sessão",
    myschedule_availability_abty_not_given: "Informe / Modifique sua disponibilidade.",
    myschedule_statusCard_completed: "Sessões concluídas",
    myschedule_statusCard_remaining: "Sessões restantes",
    myschedule_statusCard_scheduled: "Sessões a serem agendadas",
    myschedule_statusCard_lost: "Sessões perdidas (cancelada sem antecedência ou ausente)",
    myschedule_recentUpcoming_courseName: "Nome do curso",
    myschedule_next_session: "Próxima sessão",
    myschedule_session_topic: "Tema da sessão",
    myschedule_sessionDetails_communication: "Comunicação",
    myschedule_sessionDetails_allSessions: "Todas as sessões",
    myschedule_sessionDetails_upcomingSessions: "Próximas sessões",
    myschedule_sessionDetails_completedSessions: "Sessões concluídas",
    myschedule_sessionDetails_missedSessions: "Sessões perdidas",
    myschedule_sessionDetails_teacher_name: "Professor",
    myschedule_sessionDetails_sessions: "Número",
    myschedule_sessionDetails_date: "Data",
    myschedule_sessionDetails_time: "Horário",
    myschedule_sessionDetails_durationText: "Duração",
    myschedule_sessionDetails_min: "Min.",
    myschedule_reschedule_Title: "Como reagendar sua sessão",
    myschedule_reschedule_InstrBegin: "Veja como você pode reagendar suas sessões com seu instructor:",
    myschedule_reschedule_instr1a: "Verifique os detalhes da sessão no topo",
    myschedule_reschedule_instr1b: "A data e hora da sua sessão são mostradas na parte superior.",
    myschedule_reschedule_instr2: "A disponibilidade do instrutor é exibida em verde",
    myschedule_reschedule_instr3:
      "Você poderá ver a disponibilidade do seu instrutor. Os horários disponíveis são exibidos em verde.",
    myschedule_reschedule_instr4: "Selecione um horário para reagendar",
    myschedule_reschedule_instr5:
      "Para reagendar, clique na área verde de horários disponíveis e escolha o seu novo horário.",
    myschedule_reschedule_next_instr1: "Sem horário adequado",
    myschedule_reschedule_next_instr2:
      "Evite cancelamentos. Caso não consiga encontrar um horário adequado com o seu instrutor, use o botão “SEM HORÁRIO ADEQUADO” para cancelar sua sessão. Nesse caso, o seu instrutor agendará esta sessão para você ou um administrador o ajudará.",
    myschedule_reschedule_next_instr3: "Mude seu instrutor",
    myschedule_reschedule_next_instr4a:
      "Para mudar o seu instrutor para uma ou mais das suas sessões restantes, por favor use nosso",
    myschedule_reschedule_next_instr4b: "formulário de contato",
    myschedule_reschedule_next_instr4c:
      "e selecione {productname} + 'mudar de instrutor'. Por favor, forneça um motivo pelo qual você gostaria de mudar de instrutor.",
    myschedule_rechedule_next_info:
      "Para mais informações sobre as opções de reagendamento e cancelamento do instrutor, por favor, visite nossa",
    myschedule_rechedule_next_faq: "Página de perguntas frequentes.",
    myschedule_rechedule_next_noShow: "Não mostre esta página de informações novamente",
    myschedule_rechedule_next_done: "Concluído",
    myschedule_rechedule_skipButton: "Pular",
    myschedule_upcoming_joinNow: "Ingressar agora",
    myschedule_cancel_question: "Tem certeza de que deseja cancelar esta sessão?",
    myschedule_cancel_button: "Cancelar sessão",
    myschedule_cancel_no: "Não",
    myschedule_invalid_session: "Não há sessões para este curso.",
    myschedule_sessionDuraion_minutes: "Minutos",
    myschedule_homepage_view: "Visualizar",
    myschedule_finished_status: "Concluído",
    myschedule_reschedule_button: "Reagendar",
    myschedule_addToCalendar_instr1: "Clique no",
    myschedule_addToCalendar_instr2:
      "botão de download para obter sua programação da Learnship. Você pode então adicioná-la ao seu calendário pessoal.",
    myschedule_addToCalendar_instr3:
      "Se você já havia adicionado um cronograma da Learnship ao seu calendário, certifique-se de excluir o existente primeiro.",
    myschedule_addToCalendar_instr4:
      "Saiba mais sobre como adicionar a programação da Learnship ao seu calendário pessoal",
    myschedule_addToCalendar_instr5: "Aqui",
    myschedule_no_teacher_title: "Professor não atribuído",
    myschedule_no_teacher_body:
      "Nenhuma sessão pode ser adicionada no momento (nenhum professor atribuído). Entre em contato com coach@learnship.com para continuar com seu programa.",
    myschedule_no_all_sessions: "Nenhuma sessão encontrada",
    myschedule_no_upcoming_sessions: "Nenhuma sessão futura encontrada",
    myschedule_no_missed_sessions: "Nenhuma sessão perdida encontrada",
    myschedule_no_completed_sessions: "Nenhuma sessão concluída encontrada",
    myschedule_status_lost: "Perdida",
    myschedule_status_finished: "Finalizada",
    myschedule_status_completed: "Concluída",
    myschedule_status_cancelled: "Cancelada",
    myschedule_status_inprogress: "Em andamento",
    myschedule_status_pending: "Pendente",
    myschedule_status_active: "Ativa",
    myschedule_status_inplanning: "Em planejamento",
    // my schedule page translations end
    // Progress page
    progress_title: "Meu progresso",
    progress_activity_report: "Relatório de atividade",
    progress_test_results: "Resultados dos testes",
    progress_productname_sprint_skills: "Sprint Business Skills",
    progress_productname_reach_skills: "Reach Skills",
    progress_skill_note:
      "Você deve completar 70% ou mais dos trabalhos e sessões do curso para ser elegível a um certificado de conclusão.",
    progress_overall_card_title_prework: "Trabalho prévio concluído",
    progress_overall_card_title_homework: "Tarefa de casa concluída",
    progress_overall_card_title_session: "Sessão concluída",
    progress_overall_card_title_certificate: "Certificado",
    progress_overall_card_title_skillsCompleted: "Competências concluídas",
    progress_overall_card_title_badgesEarned: "Emblemas conquistados",
    progress_overall_card_title_missionsPassed: "Missão cumprida",
    progress_overall_card_title_timeInReach: "Tempo no reach (hh:mm)",
    progress_noSubskill: "Não há habilidade para mostrar.",
    progress_tab_nodata: "Não há dados para mostrar aqui.",
    progress_tab_notonboarded: "Conclua sua integração para acessar seus relatórios",
    progress_activityreport_nodata:
      "Atualmente, não há dados para mostrar aqui. Continue aprendendo e volte mais tarde",
    progress_percentCompleted: "Porcentagem concluída",
    progress_subskill_preworkTitle: "Trabalho prévio",
    progress_subskill_homeworkTitle: "Tarefa de casa",
    progress_subskill_sessionTitle: "Sessão",
    progress_subskill_sessionStatusCompleted: "Concluída",
    progress_subskill_sessionStatusNotCompleted: "Não concluída",
    progress_subskill_sessionStatusNoSessions: "Sem sessões",
    progress_subskill_sessionStatusAbsent: "Ausente",
    progress_subskill_sessionNoDate: "N/a",
    progress_activity_tooltip_totaltime: "Tempo total",
    progress_activity_tooltip_activitiesCompleted: "Atividades concluídas",
    progress_activity_tooltip_reachMissionsCompleted: "Missões do reach concluídas",
    progress_activity_tooltip_timeinhhmm: "Tempo em hh: mm",
    progress_activity_tabDaily: "Diário",
    progress_activity_tabWeekly: "Semanal",
    progress_activity_tabMonthly: "Mensal",
    progress_activity_tabQuarterly: "Trimestral",
    progress_activity_tabQuarter: "Trimestre",
    progress_activity_tabYearly: "Anual",
    progress_acitivity_Minutes: "Minutos",
    progress_acitivity_legend_selfpaced: "Tempo de auto-aprendizagem",
    progress_acitivity_legend_trainerLed: "Tempo conduzido pelo instrutor",
    progress_acitivity_legend_recommended: "Recomendado",
    progress_testresults_table_testname: "Nome do teste",
    progress_testresults_table_scores: "Pontos",
    progress_testresults_table_date: "Data",
    progress_testresults_placed_text: "Placed",
    progress_test_result_timer_text: "*Your test results will appear in 24 hours.",
    progress_testresults_info: "Os resultados dos seus testes serão exibidos em 24 horas",
    progress_inprogress: "Em andamento",
    progress_totalscore: "Pontuação total",
    progress_placedText: "Posição",
    progress_button_viewscore: "Ver relatório detalhado",
    progress_certificate_download_success: "Baixado com sucesso",
    progress_partText: "Parte",
    progress_emptyPartText: "Outro",
    progress_overall_card_title_badge: "Emblema",
    progress_total_correctness_percentage: "Your success score is: ",
    progress_badge_dialog_box_title:
      "Para obter um certificado de conclusão, exigimos a realização de 70% dos exercícios digitais.",
    progress_badge_dialog_box_golden: "Uma pontuação de sucesso de 80% ganha um emblema de ouro",
    progress_badge_dialog_box_silver: "Uma pontuação de sucesso entre 70% e 79% ganha um emblema de prata",
    progress_badge_dialog_box_bronze: "Uma pontuação de sucesso entre 50% a 69% ganha um emblema de bronze",
    progerss_badge_dailog_box_digitalActivities:
      "A pontuação de sucesso é calculada com base no seu desempenho e envolvimento com as atividades digitais online",
    progress_badge_dailog_box_liveSessions:
      "A pontuação de sucesso é calculada com base no seu desempenho e envolvimento com as atividades digitais online e sessões ao vivo",
    progress_elevate_dialog_box_liveSessions:
      "The success score is calculated based on your performance and engagement with live sessions",
    // Idle Timer
    session_expiring: "Sessão expirando",
    timer_title_1: "Sua sessão está prestes a expirar.",
    timer_title_2: "Para continuar estudando, clique em Ok.",
    ok_timer: "Ok",
    //EO Progress page
    //Email Templates
    wcTitle: "Centro de Redação",
    guidelines: "Diretrizes de escrita",
    sampleDocs: "Documentos de amostra",
    languageSelect: "Select a language",
    wcGroup1: "Pedidos de desculpas",
    wcGroup2: "Reclamações",
    wcGroup3: "Elogios",
    wcGroup4: "Felicitações",
    wcGroup5: "Documentos",
    wcGroup6: "Convites",
    wcGroup7: "Ofertas de emprego",
    wcGroup8: "Marketing e vendas",
    wcGroup9: "Reuniões",
    wcGroup10: "Avisos",
    wcGroup11: "Pedidos",
    wcGroup12: "Informações sobre preços",
    wcGroup13: "Solicitações",
    wcGroup14: "Obrigado",
    wcTitle11: "Pedido de desculpas por atraso em projeto",
    wcTitle12: "Pedido de desculpas por erro em conta",
    wcTitle13: "Pedido de desculpas por atraso na entrega",
    wcTitle14: "Pedido de desculpas por entrega de mercadoria danificada",
    wcTitle15: "Pedido de desculpas por faltar a uma reunião",
    wcTitle21: "Reclamação Geral",
    wcTitle22: "Reclamação sobre um problema com um produto",
    wcTitle23: "Reclamação sobre cobrança indevida em conta",
    wcTitle31: "Elogio a um colega por um projeto",
    wcTitle32: "Elogio ao serviço de atendimento ao cliente",
    wcTitle33: "Elogio a um produto",
    wcTitle41: "Parabenização por uma promoção (formal)",
    wcTitle42: "Parabenização por uma promoção (informal)",
    wcTitle43: "Parabenização por um acontecimento pessoal",
    wcTitle51: "Documento solicitado",
    wcTitle52: "Formulário de pedido ou Ordem de compra",
    wcTitle53: "Fatura",
    wcTitle61: "Convite para um evento social",
    wcTitle62: "Convite para um evento de negócios",
    wcTitle63: "Aceitando um convite",
    wcTitle64: "Recusando um convite",
    wcTitle65: "Cancelando um evento de negócios",
    wcTitle71: "Confirmação de recebimento do pedido",
    wcTitle81: "Anúncio de um novo produto",
    wcTitle82: "Anúncio de um novo representante de área",
    wcTitle83: "Demonstração de novo produto",
    wcTitle84: "Mudança de endereço de cobrança",
    wcTitle85: "Acompanhamento após a primeira reunião de vendas",
    wcTitle86: "Boas-vindas a novos clientes",
    wcTitle87: "Mensagem de feriado para acionistas ou clientes",
    wcTitle91: "Propondo um horário para uma reunião",
    wcTitle92: "Confirmando uma reunião",
    wcTitle93: "Adiando uma reunião",
    wcTitle94: "Cancelamento de uma reunião",
    wcTitle95: "Resumindo uma reunião",
    wcTitle101: "Conta suspensa",
    wcTitle102: "Solicitação de encerramento de conta",
    wcTitle111: "Confirmando um pedido",
    wcTitle112: "Confirmação de envio de mercadoria",
    wcTitle113: "Cancelando um pedido",
    wcTitle114: "Alterando um Pedido",
    wcTitle115: "Confirmando uma entrega",
    wcTitle121: "Envio de informações de preços",
    wcTitle122: "Aceitação de cotação de preço",
    wcTitle123: "Recusa de cotação de preço",
    wcTitle131: "Pedido de esclarecimento de informação",
    wcTitle132: "Pedido de informação sobre um produto",
    wcTitle133: "Pedido de informação sobre um serviço",
    wcTitle141: "Agradecimento Geral",
    guideGroup1: "Problemas comuns de escrita",
    guideGroup2: "Comunicação geral de negócios",
    guideGroup3: "Documentos de negócio",
    guideTitle11: "Razões para uma escrita pouco clara",
    guideTitle12: "Erros básicos de escrita",
    guideTitle13: "Problemas com verbos",
    guideTitle21: "Franqueza na comunicação de negócios",
    guideTitle22: "Linguagem para vendas e marketing",
    guideTitle23: "Expressões de negócios cotidianas",
    guideTitle31: "E-mails eficazes",
    guideTitle32: "Apresentações: dicas gerais",
    guideTitle33: "Apresentações: aberturas eficazes",
    backIndex: "Voltar para o índice",
    copyText: "Copiar texto",
    exportEmail: "Exportar texto para e-mail",
    beActivity: "Nível de Inglês Comercial <course>, Tarefa <assign>, Atividade <act>",
    Blob: "Os modelos de e-mail abrangem uma ampla variedade de assuntos sobre o mundo dos negócios. Selecione o modelo desejado e exporte-o diretamente para o seu e-mail de trabalho, onde poderá editá-lo.",
    OpenInEmail: "Abrir no e-mail",
    Quote1: "Existem atualmente 3,3 bilhões de contas de e-mail no mundo.",
    Quote1By: "Mashable",
    Quote2: "O e-mail gera quase o dobro do retorno em comparação a outros canais.",
    Quote2By: "Líder de marketing direto",
    Quote3: "3,5 milhões de e-mails são enviados por segundo.",
    Quote3By: "Líder de marketing",
    SelectACategory: "Selecione uma categoria",
    Title: "Modelos de e-mail",
    WatchTutorial: "Assista a um tutorial em vídeo",
    String: "Citação1",
    //Culture Notes Dropdowns
    NoAm: "América do Norte",
    Cenam: "América Central",
    SoAm: "América do Sul",
    EUR: "Europa",
    ASIA: "Ásia",
    CenASIA: "Ásia Central",
    SoEASIA: "Sudeste da Ásia",
    MidEAST: "Oriente Médio",
    AFR: "África",
    AUST: "Austrália",
    Cana: "Canadá",
    Mexi: "México",
    Uniteds: "Estados Unidos",
    CostaR: "Costa Rica",
    DomRep: "República Dominicana",
    Guate: "Guatemala",
    Jama: "Jamaica",
    Panam: "Panamá",
    TriniTob: "Trinidad e Tobago",
    Arge: "Argentina",
    Braz: "Brasil",
    Chil: "Chile",
    Vene: "Venezuela",
    Colomb: "Colômbia",
    Peru: "Peru",
    Urug: "Uruguai",
    Austria: "Áustria",
    Belg: "Bélgica",
    Bulg: "Bulgária",
    Croatia: "Croácia",
    Czec: "República Tcheca",
    Denm: "Dinamarca",
    Finl: "Finlândia",
    Fran: "França",
    Germ: "Alemanha",
    Greec: "Grécia",
    Hung: "Hungria",
    Icel: "Islândia",
    Irel: "Irlanda",
    Ital: "Itália",
    Lith: "Lituânia",
    Luxem: "Luxemburgo",
    Neth: "Holanda",
    Norw: "Noruega",
    Pola: "Polônia",
    Port: "Portugal",
    Roma: "Romênia",
    Russ: "Federação Russa",
    Serb: "Sérvia",
    Slovakia: "Eslováquia",
    Slovania: "Eslovênia",
    Spai: "Espanha",
    Swed: "Suécia",
    Swit: "Suíça",
    Turk: "Turquia",
    Ukra: "Ucrânia",
    Unitedk: "Reino Unido",
    Chin: "China",
    Hong: "Hong Kong",
    Indi: "Índia",
    Japa: "Japão",
    Mongo: "Mongólia",
    Pakis: "Paquistão",
    SoKore: "Coréia do Sul",
    SriLan: "Sri Lanka",
    Taiw: "Taiwan",
    Afgh: "Afeganistão",
    Azer: "Azerbaijão",
    Kaza: "Cazaquistão",
    Camb: "Camboja",
    Indo: "Indonésia",
    Malay: "Malásia",
    Phil: "Filipinas",
    Sing: "Cingapura",
    Thai: "Tailândia",
    Viet: "Vietnã",
    Bah: "Bahrain",
    Iran: "Irã",
    Iraq: "Iraque",
    Isra: "Israel",
    Jor: "Jordânia",
    Kuw: "Kuwait",
    Leb: "Líbano",
    Oma: "Omã",
    Qat: "Catar",
    SauArb: "Arábia Saudita",
    UAE: "Emirados Árabes Unidos",
    Alger: "Argélia",
    Angol: "Angola",
    Egyp: "Egito",
    Ghana: "Gana",
    Guin: "Guiné",
    Keny: "Quênia",
    Malaw: "Malaui",
    Moroc: "Marrocos",
    Mozam: "Moçambique",
    Nige: "Nigéria",
    SoAfr: "África do Sul",
    Tanz: "Tanzânia",
    Ugan: "Uganda",
    Zamb: "Zâmbia",
    Austra: "Austrália",
    NewZea: "Nova Zelândia",
    //Culture Notes Dropdowns End
    culturenotes_mainintrotext:
      "Familiarize-se com as culturas das regiões que são importantes para seus negócios e vida profissional.",
    culturenotes_useculturalinfo:
      "Use nossas informações culturais para se preparar para reuniões importantes com clientes e colegas de trabalho em todo o mundo.",
    culturenotes_topicfamiliarize:
      "Familiarize-se com os costumes de outras culturas, tais como o horário comercial, jantar fora, presentear alguém, etc.",
    culturenotes_topiclearnculture:
      "Saiba mais sobre as práticas e diferenças culturais, além dos costumes locais para evitar equívocos.",
    culturenotes_tmaworldtext:
      "Os relatórios dos países são desenvolvidos por nosso parceiro tma world e estão disponíveis em versões pdf para download.",
    culturenoteslocation_viewbytopic: "Visualizar por tópico",
    culturenoteslocation_viewbycountry: "Visualizar por país",
    culurecenter_disclaimer_title: "Isenção de responsabilidade",
    culturecenter_disclaimer:
      "or favor, trate as informações que você vai ler como um guia geral, que deve ser um ponto de partida para se familiarizar com uma nova cultura. Esta ferramenta irá ajudá-lo a aprender sobre padrões culturais comuns, o que servirá como base para melhor compreender e interpretar as diferenças culturais no comportamento, atitudes e reações das pessoas. No entanto, é importante ter em mente que as características comuns de uma determinada cultura variam regionalmente e por personalidade individual.​​",
    culturecenter_intercept_title: "O Centro de Cultura está de volta!​​",
    culturecenter_intercept_text1:
      "Depois de alguns retoques, temos o prazer de anunciar que o Centro de Cultura está de volta!",
    culturecenter_intercept_text2:
      "Com o Centro de Cultura, você aprende mais sobre as práticas e costumes profissionais em 20 países ao redor do mundo, incluindo EUA, Canadá, México, China, Japão, Índia e muitos outros...",
    culturecenter_intercept_direct: "Ir para o Centro de Cultura​",
    dailyNewsFeed_resources: "Recursos",
    dailyNewsFeed_daily_News: "News feed diário",
    dailyNewsFeed_newsfeedoftheday: "News feed do dia[NK1] ",
    dailyNewsFeed_feedcontent:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor orci at quam porta dictum. Duis id vestibulum dui. Phasellus interdum augue magna, in tempus velit imperdiet id.",
    dailyNewsFeed_noData: "Desculpe, não foi possível obter o seu news feed[NK2]  diário, tente novamente mais tarde.",
    dailyNewsFeed_viewMoreCategories: "Ver mais categorias",
    // Email templates end
    //Error Page Translations
    error_not_found: "Ops! Página não encontrada.",
    error_contact_csm: "Por favor, entre em contato com seu gerente de sucesso de clientes para obter ajuda.",
    error_under: "em",
    error_maintenance: "manutenção",
    error_under_maintenance: "Nosso site está em manutenção programada.",
    error_inconvenience: "Lamentamos qualquer inconveniente.",
    error_tryagain: "Por favor, tente novamente mais tarde.",
    error_tryagainMins: "Por favor, tente novamente em",
    error_minutes: "Minuto(s)",
    error_hours: "Hora(s)",
    error_oops: "Ops!",
    error_permission_denied: "Você não tem permissão para visualizar esta página!",
    error_link_home: "Página inicial",
    error_contact_admin: "Por favor, entre em contato com seu administrador da Learnship para obter ajuda.",
    error_sorry: "Pedimos desculpas.",
    error_load: "Houve um problema ao carregar esta página.",
    error_clear_cache: "Por favor, limpe o cache do seu navegador, verifique sua conexão e tente novamente.",
    error_contact: "Por favor, entre em contato com a nossa",
    error_contact_cst: "equipe de suporte ao cliente",
    error_forhelp: "Para solicitar ajuda.",
    error_having_trouble: "Ainda está tendo problemas?",
    //Accents and Dialects Dropdowns
    AF: "África",
    AS: "Ásia",
    AU: "Austrália-oceania",
    CA: "Caribe",
    CE: "América Central",
    EU: "Europa",
    MI: "Oriente Médio",
    NO: "América do Norte",
    SO: "América do Sul",
    CAMER: "República de Camarões",
    EGYPT: "Egito",
    ETHIO: "Etiópia",
    GHANA: "Gana",
    GUINE: "Guiné",
    NIGER: "Nigéria",
    SOUTH: "África do Sul",
    TANZA: "Tanzânia",
    AFGHA: "Afeganistão",
    CHINA: "China",
    INDIA: "Índia",
    INDON: "Indonésia",
    JAPAN: "Japão",
    KAZAK: "Cazaquistão",
    LEBAN: "Líbano",
    MONGO: "Mongólia",
    NORTH: "Vietnã do Norte",
    PAKIS: "Paquistão",
    PHILI: "Filipinas",
    SINGA: "Cingapura",
    KOREA: "Coréia",
    SRI_L: "Sri lanka",
    TAIWA: "Taiwan",
    THAIL: "Tailândia",
    TURKM: "Turcomenistão",
    AUSTR: "Austrália",
    FIJI_: "Fiji",
    NEW_Z: "Nova Zelândia",
    BERMU: "Bermudas",
    CUBA_: "Cuba",
    HAITI: "Haiti",
    COSTA: "Costa Rica",
    GUATE: "Guatemala",
    MARTI: "Martinica (Francesa)",
    TRINI: "Trinidad e Tobago",
    AUSTRI: "Áustria",
    BELAR: "Bielorrússia",
    BELGI: "Bélgica",
    BULGA: "Bulgária",
    CYPRU: "Chipre",
    CZECH: "República Tcheca",
    DENMA: "Dinamarca",
    ENGLA: "Inglaterra",
    FINLA: "Finlândia",
    FRANC: "França",
    GEORG: "Geórgia",
    GERMA: "Alemanha",
    GREEC: "Grécia-Hélade",
    HUNGA: "Hungria",
    IRELA: "Russi",
    ITALY: "Itália",
    MACED: "Macedônia do Norte",
    NETHE: "Países Baixos",
    NORTHI: "Irlanda do Norte",
    POLAN: "Polônia",
    ROMAN: "Romênia",
    RUSSI: "Federação Russa",
    SCOTL: "Escócia",
    SPAIN: "Espanha",
    SWEDE: "Suécia",
    SWITZ: "Suíça",
    TURKE: "Turquia",
    UKRAI: "Ucrânia",
    WALES: "País de Gales",
    IRAN_: "Irã",
    IRAQ_: "Iraque",
    ISRAE: "Israel",
    KUWAI: "Kuwait",
    SAUDI: "Arábia Saudita",
    SYRIA: "Síria",
    CANAD: "Canadá",
    MEXIC: "México",
    ARGEN: "Argentina",
    BRAZI: "Brasil",
    CHILE: "Chile",
    COLOM: "Colômbia",
    PARAG: "Paraguai",
    PERU_: "Peru",
    VENEZ: "Venezuela",
    RPTitle: "Rainbow passage",
    CGACTitle: "Comma Gets a Cure",
    accentsAndDialects_heading: "Sotaques e dialetos",
    US: "Estados Unidos da América",
    ALABA: "Alabama",
    ALASK: "Alaska",
    ARKAN: "Arkansas",
    CALIF: "Califórnia",
    FLORI: "Flórida",
    GEORG_US: "Geórgia",
    HAWAI: "Havaí",
    ILLIN: "Illinois",
    INDIA_US: "Indiana",
    KANSA: "Kansas",
    KENTU: "Kentucky",
    LOUIS: "Louisiana",
    MAINE: "Maine",
    MARYL: "Maryland",
    MASSA: "Massachusetts",
    MICHI: "Michigan",
    MINNE: "Minnesota",
    MISSI: "Mississippi",
    MISSO: "Missouri",
    MONTA: "Montana",
    NEBRA: "Nebraska",
    NEW_H: "New Hampshire",
    NEW_J: "Nova Jérsei",
    NEW_Y: "Nova Iorque",
    NCARO: "Carolina do Norte",
    NDAKO: "Dakota do Norte",
    OHIO_: "Ohio",
    OKLAH: "Oklahoma",
    PENNS: "Pennsylvania",
    SOUTH_US: "Carolina do Sul",
    TENNE: "Tennessee",
    TEXAS: "Texas",
    VIRGI: "Virgínia",
    WEST_: "Virgínia do Oeste",
    WISCO: "Wisconsin",
    //Accents and Dialects Dropdowns End
    manager_email_managertext:
      "Sua empresa solicitou um relatório mensal para o seu gerente indicando o seu progresso na Learnship. Forneça o e-mail do seu gerente abaixo.",
    // survey and notification
    notification_description_plural:
      "{Days} dias restantes para completar a pesquisa. Você deve concluí-la até {date}.",
    notification_description_singular: "1 dia restante para completar a pesquisa. Você deve concluí-la até {date}.",
    notification_maintenance_message: "Halo estará em manutenção programada em {date} às {time}.",
    //renewal
    renewal_welcome: "Bem-vindo(a) de volta à Learnship!",
    renewal_text:
      "Sua licença da Learnship irá expirar em {date} de {month} de {year}. Para continuar melhorando suas habilidades em comunicação em inglês para negócios, renove a sua licença hoje. O seu plano de estudos e todo o seu trabalho serão salvos e você continuará no seu nível atual.",
    renewal_later: "Por favor, pergunte-me mais tarde.",
    renewal_affirmative: "Eu quero renovar a minha licença.",
    renewal_negative: "Eu não quero renovar a minha licença.",
    renewal_yes: "Sim",
    renewal_no: "Não",
    courselevel: "Nível do curso",
    currentunit: "Unidade atual",
    upcomingsession: "Próxima sessão",
    viewschedule: "Ver horário",
    currentskills: "Habilidades",
    currentsubskills: "Sub-habilidades",
    // TWT translations
    twt_talk_with_teacher_title: "Talk with the Teacher",
    twt_sub_heading:
      "Pratique suas habilidades de conversação com um professor e outros alunos em nossa sala de aula online!",
    twt_select_sessions: "Selecione suas sessões",
    twt_view_schedule_title: "Veja o horário e adicione-o ao calendário",
    twt_next_week: "Próxima semana",
    twt_previous_week: "Semana anterior",
    twt_add_to_calendar: "Adicione ao calendário",
    twt_view_more: "Veja mais",
    twt_topic: "Tema",
    twt_class_policy_title: "Talk with the Teacher (TWT) políticas e diretrizes.",
    twt_class_policy_subHeading:
      "As políticas e diretrizes a seguir são importantes para garantir que sua experiência na sessão de Talk with the Teacher seja educativa e agradável. Por favor, leia-as com atenção.",
    twt_class_policy_list01:
      "Você pode assistir a uma aula por semana. Nossas salas de aula online têm um limite de oito alunos. Para ter melhor chance de conseguir um lugar em uma sala de aula online, você deve chegar perto do início da sessão. As salas de aula do Talk with the Teacher estão disponíveis somente durante os primeiros 10 minutos de cada aula. Por exemplo, uma sessão que começa às 9:00 está acessível até às 9:10. Após os primeiros 10 minutos, você não poderá ingressar na sessão.",
    twt_class_policy_list02_sub1:
      "Quando você entrar na sala de aula, digite seu nome, cidade, país e nível na caixa de bate-papo.",
    twt_class_policy_list02_sub2: "Meu nome é Leo e sou de São Paulo, Brasil. Estou no nível 6.",
    twt_class_policy_list02_sub3: "O instrutor irá então ativar o seu microfone e o ícone do microfone aparecerá.",
    twt_class_policy_list03:
      "Se você tiver um problema técnico, entre em contato com o suporte ao cliente. Clique em ajuda na parte superior de qualquer página. Por favor, não peça ajuda técnica ao instrutor.",
    twt_class_policy_list04:
      "Assista à orientação do Talk with the Teacher antes de entrar na sala de aula online. Esta orientação lhe dará informações valiosas sobre como participar da aula online.",
    twt_class_policy_list05:
      "Existem quatro níveis de sessão do Talk with the Teacher (TWT): iniciante, intermediário, avançado e todos os níveis. Você deve ir a uma sessão que seja apropriada para sua habilidade em inglês. Por exemplo, se você estiver nos níveis 0-3, deverá ir para uma sessão iniciante do Talk with the Teacher. Todos os alunos podem assistir às aulas de todos os níveis. Se você participar de uma sessão do Talk with the Teacher que não seja apropriada para sua habilidade em inglês, seu instrutor informará que você não está na aula correta e sua sessão será encerrada.",
    twt_class_policy_list06:
      "Se você gostaria de participar de uma aula online apenas ouvindo, pode fazê-lo durante uma hora por semana. Depois disso, você deve participar falando durante a aula. Você pode ouvir sem falar por um total de quatro aulas por ano. Se ultrapassar esse limite e não começar a participar da aula, sua sessão poderá ser encerrada.",
    twt_class_policy_ok: "Ok",
    twt_max_multi_window_error_message:
      "Você já entrou nesta sessão através de outro dispositivo. Por favor, faça o logout antes de entrar no dispositivo atual.",
    twt_max_capacity_error_message:
      "Lamentamos que você não possa participar desta sessão, pois ela atingiu sua capacidade máxima. Por favor, participe de outra sessão.",
    twt_notification_message: "Tem uma sessão de conversa que começa agora mesmo. Você quer participar?",
    twt_limit_message: "Você já participou de uma classe esta semana.",
    twt_session_unavailable: "Nenhuma sessão disponível",
    twt_select_language: "Selecione o idioma",
    //Vocabulary center translations
    search:"Pesquise",
    vocab_center_product_headline: "Centro de Vocabulário",
    vocab_center_search_word: "Pesquise e acrescente palavras",
    vocab_center_add_wordlist: "Adicione Lista de Palavras",
    vocab_center_edit_wordlist: "Editar Lista de Palavras",
    vocab_center_delete_wordlist: "Apagar Lista de Palavras",
    vocab_center_options_text: "Opções",
    vocab_center_add_word: "Adicione palavra",
    vocab_center_add_text: "Adicione",
    vocab_center_delete_wordlist_warning_message:
      "Todas as palavras da lista serão apagadas. Clique em sim para apagar.",
    vocab_center_yes_text: "Sim",
    vocab_center_new_wordlist: "Nova Lista de Palavras",
    vocab_center_created_wordlist_success_message: "Você criou com sucesso sua nova Lista de Palavras",
    vocab_center_updated_wordlist_success_message: "Você atualizou com sucesso sua Lista de Palavras",
    vocab_center_okay_text: "Ok",
    vocab_center_new_word_text: "Palavra nova",
    vocab_center_enter_word_text: "Digite uma palavra",
    vocab_center_wordlist_exists: "This wordlist already exists.",
    vocab_center_word_exists_in_wordlist_warning_message: "Esta palavra já existe nesta Lista de Palavras",
    vocab_center_save_text: "Salvar",
    vocab_center_new_word_message: "Esta palavra não existe. Você quer criar sua própria definição?",
    vocab_center_pos_label: "Parte do discurso",
    vocab_center_select_wordlist_text: "Selecione uma Lista de Palavras",
    vocab_center_word_label: "Palavra",
    vocab_center_update_wordlist: "Atualizar Lista de Palavras",
    vocab_center_definition_label: "Definição",
    vocab_center_translation_label: "Tradução",
    vocab_center_sentence_label: "Frase",
    vocab_center_note_label: "Anotação",
    vocab_center_cancel_text: "Cancelar",
    vocab_center_delete_word_text: "Apagar palavra",
    vocab_center_delete_word_warning_message: "Você tem certeza de que quer apagar esta palavra da Lista de Palavras?",
    vocab_center_note_updated_message: "Suas anotações foram atualizadas com sucesso!!",
    vocab_center_close_text: "Fechar",
    vocab_center_no_definition_text: "Nenhuma definição disponível",
    vocab_center_no_translation_text: "Nenhuma tradução disponível",
    vocab_center_no_sentence_text: "Nenhuma frase disponível",
    vocab_center_no_note_text: "Nenhuma anotação adicionada",
    vocab_center_word_save_message: "Você salvou com sucesso a palavra em sua Lista de Palavras",
    vocab_center_word_exists_error_message: "A palavra selecionada já existe na mesma Lista de Palavras",
    vocab_center_submit_text: "Enviar",
    vocab_center_delete_text: "Apagar",
    vocab_center_edit_text: "Editar",
    vocab_center_no_word_message: "Ops! Não há palavras em sua lista de palavras. Adicione novas palavras!",
    vocab_center_no_wordlist_message:
      "Ops! Não há listas de palavras em {Word List Name}. Adicionar nova lista de palavras!",
    vocab_center_enter_wordlist_text: "Insira uma lista de palavras",
    vocab_center_feature_text:
      "Sem gramática, muito pouco pode ser transmitido. Sem vocabulário, nada pode ser transmitido. - David Wilkins",
    vocab_center_feature_summary:
      "Explore e expanda seu léxico sem esforço com o Centro de Vocabulário, sua porta de entrada para descobrir e dominar novas palavras sem problemas",
    // Stress and inotation translations
    stress_intonation_product_headline: "Ênfase e entonação",
    stress_intonation_product_description:
      "Torne seu inglês mais natural e fácil de entender, aprendendo a usar a ênfase, o ritmo e a entonação corretos ao falar.",
    // Sounds of English translations
    soe_product_headline: "Sons do inglês",
    soe_product_description:
      "Melhore suas habilidades de comunicação aprendendo a pronunciar os sons do inglês corretamente.",
    soe_product_vowels: "Vogais",
    soe_product_consonants: "Consoantes",
    soe_product_language_selection:
      "Selecione seu idioma na lista suspensa para encontrar os sons que podem ser difíceis para os falantes do seu idioma. Em seguida, selecione meus sons para encontrar os sons com os quais você teve problemas nas atividades prática de pronúncia e prática de comunicação.",
    // Writing center
    wc_feature_headline: "Centro de Redação",
    wc_feature_description:
      "Aumente o nível de sua capacidade de escrita profissional através dos nossos recursos direcionados.",
    wc_feature_guideGroup1: "Problemas comuns de escrita",
    wc_feature_guideGroup2: "Comunicação geral de negócios",
    wc_feature_guideGroup3: "Documentos de negócio",
    wc_feature_guideTitle11: "Razões para uma escrita pouco clara",
    wc_feature_guideTitle12: "Erros básicos de escrita",
    wc_feature_guideTitle13: "Problemas com verbos",
    wc_feature_guideTitle21: "Franqueza na comunicação de negócios",
    wc_feature_guideTitle22: "Linguagem para vendas e marketing",
    wc_feature_guideTitle23: "Expressões de negócios cotidianas",
    wc_feature_guideTitle31: "E-mails eficazes",
    wc_feature_guideTitle32: "Apresentações: dicas gerais",
    wc_feature_guideTitle33: "Apresentações: aberturas eficazes",
    // sso leaner intercept
    learners_intercept_title: "AVISO IMPORTANTE",
    learners_intercept_text1:
      "A forma de acessar a Learnship está mudando! Citi e Learnship criaram uma parceria para habilitar um acesso simples e unificado para todos os estudantes globais. A partir de 05:00 (São Paulo) do dia 18 de novembro de 2022, você será direcionado para o link\u202f",
    learners_intercept_text2:
      "para acessar a plataforma. É importante notar que não será mais necessário o acesso antigo via portal da\u202f",
    learners_intercept_text3: "Por gentileza anote esta mudança e adicione esta nova página aos seus favoritos. ",
    learners_intercept_text4: "Para dúvidas e suporte, por gentileza procure seu RH local ou\u202f",
    // google learner intercept
    google_intercept_title: "Important Notice",
    google_intercept_subtitle: "The way you log on to Learnship is changing! ",
    google_intercept_text1: "Google has partnered with Learnship to enable ",
    google_intercept_text2: "for all learners. ",
    google_intercept_text3: "Effective from ",
    google_intercept_text4: "you will be required to go to ",
    google_intercept_text5: "It is important to note that, from ",
    google_intercept_text6: ", you will no longer be able to access your Learnship course through ",
    google_intercept_text7:
      "Please make a note of the above change and remember to delete any old bookmarks and replace it with the new link.",
    google_intercept_text8: "For support, please reach out to ",
    google_sso_text: " Single Sign On (SSO) ",
    google_dd_mmm_text: "18th May",
    google_intercept_time: "10:00am CEST",
    google_intercept_date: "18 May 2023",
    google_intercept_on_text: "on",
    google_link_not_work: "This link will not work before that date.",
    learnship_note_google: "Note: ",
    learnship_family_note_google:
      "This change only applies to Googlers. Family members will continue to log in as before.",
    // nestle learner intercept
    nestle_intercept_title: "Important Notice",
    nestle_intercept_subtitle: "The way you log on to Learnship is changing! ",
    nestle_intercept_text1: "Nestlé has partnered with Learnship to enable ",
    nestle_intercept_text2: "for all learners in Switzerland. ",
    nestle_intercept_text3: "Effective from ",
    nestle_intercept_text4: "you will be required to go to ",
    nestle_intercept_text5: "It is important to note that, from ",
    nestle_intercept_text6: ", you will no longer be able to access your Learnship course through ",
    nestle_intercept_text7:
      "Please make a note of the above change and remember to delete any old bookmarks and replace it with the new link.",
    nestle_intercept_text8: "For support, please reach out to your ",
    nestle_service_desk: "Nestlé ServiceDesk",
    nestle_dd_mmm_text: "4th May",
    nestle_sso_text: " Single Sign On (SSO) ",
    nestle_intercept_time: "10:00am CEST",
    nestle_intercept_date: "4th May 2023",
    nestle_intercept_on_text: "on",
    nestle_intercept_or_text: "or ",
    nestle_link_not_work: "This link will not work before that date.",
    learnship_note_nestle: "Note: ",
    learnship_family_note_nestle:
      "This change only applies to Nestlé employees. Family members will continue to log in as before.",
      welcome_Contact_number_helper_text:'Para garantir assistência imediata e suporte personalizado, é altamente recomendável fornecer também seu número de contato'
  },
};
